module.exports = __webpack_public_path__ + "static/media/accidents.3a79f596.svg";